// extracted by mini-css-extract-plugin
export default {"panel":"resource-not-found_panel__g1T8o","error-code":"resource-not-found_error-code__TRR+0","error-message":"resource-not-found_error-message__UFje7"};